export default __webpack_public_path__ + "static/icon-instagram-alt-12135e2d2e5b869f78ef6331eb52d5de.svg";